import { Flex, Group, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { DictionaryValidationAction } from '@/module/Author/Dictionary/Validation/DictionaryValidationAction';
import { DictionaryValidationHistory } from '@/module/Author/Dictionary/Validation/DictionaryValidationHistory';
import { DictionaryDeleteButton } from '@/module/Author/Dictionary/components/DictionaryDeleteButton';

import { Content, EditButtonLink } from '@/core/components';

import { AuthorList } from '@feature/utils';

import { DictionaryProofAction } from './Proof';
import { Dictionary } from './model/DictionaryTypes';

interface DictionaryViewProps {
  dictionary: Dictionary;
}

export function DictionaryView(props: DictionaryViewProps) {
  const { dictionary } = props;
  const { t } = useTranslation();
  const { title, publisher, type, printType, isbnPrint, eisbn, link, authors, publicationYear } = dictionary;

  return (
    <Stack>
      <Content type="full">
        <Stack gap="4px">
          <Text
            c="dimmed"
            size="xs"
          >
            {t(`dictionaries.typeEnum.${type}`)}
          </Text>
          <Flex justify="space-between">
            <Text fw="500">{`${title} (${publicationYear})`}</Text>
            <Group>
              <EditButtonLink
                size="xs"
                miw="100px"
              />
              <DictionaryDeleteButton dictionaryId={dictionary.id} />
            </Group>
          </Flex>
          <Text size="sm">Publicat la: {publisher?.title ?? '-'}</Text>
          <Text size="sm">Isbn: {isbnPrint}</Text>
          <Text size="sm">Eisbn: {eisbn}</Text>
          <Text size="sm">
            Link:{' '}
            <Link
              to={link}
              target="_blank"
            >
              {link}
            </Link>
          </Text>
          <Text
            c="dimmed"
            size="xs"
          >
            {printType}
          </Text>
        </Stack>
      </Content>
      <Content type="full">
        <AuthorList authors={authors} />
      </Content>
      <DictionaryProofAction
        dictionaryId={dictionary.id}
        authors={authors}
      />
      <DictionaryValidationAction dictionaryId={dictionary.id} />
      <DictionaryValidationHistory dictionaryId={dictionary.id} />
    </Stack>
  );
}
